import { render, staticRenderFns } from "./txVideoPlayer.vue?vue&type=template&id=e3981d54&scoped=true&"
import script from "./txVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./txVideoPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3981d54",
  null
  
)

export default component.exports